import { useState, useCallback } from 'react';
import { getApiUrl } from '#config';

export const useSignOut = ({ onCompleted, onFinally }) => {
  const [loading, setLoading] = useState(false);
  const apiUrl = getApiUrl();

  const trigger = useCallback(async () => {
    setLoading(true);

    try {
      const uri = `${apiUrl}/auth/github/sign-out`;
      const response = await fetch(uri, {
        method: 'POST',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      if (response.ok && onCompleted) {
        onCompleted(response);
      }
    } finally {
      setLoading(false);
      if (onFinally) {
        onFinally();
      }
    }
  }, [apiUrl, onCompleted, onFinally]);

  return {
    trigger,
    loading,
  };
};
